import { render, staticRenderFns } from "./DepartmentsOrder.vue?vue&type=template&id=04e4b96f&"
import script from "./DepartmentsOrder.vue?vue&type=script&lang=js&"
export * from "./DepartmentsOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports